var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container__grid"},[_c('super-checkout-intern-header',{attrs:{"view":_vm.view}}),_vm._v(" "),_c('super-checkout-intern-body',{attrs:{"view":_vm.view,"show-load-more":_vm.showLoadMore}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589af073","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/super-checkout-intern/index.vue
// module id = lI/J
// module chunks = 0